import React, { useContext } from "react";
import {
    Button,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import ContentContext from "../../../common/context/ContentContext";
import { useNavigate } from "react-router-dom";

interface OwnProps {
    onCloseWithAutosave?: () => void;
};

const CloseButton = ({
    onCloseWithAutosave,
}: OwnProps) => {
    const content = useContext(ContentContext);
    const navigate = useNavigate();
    return <Button
        onClick={() => {
            onCloseWithAutosave
                ? onCloseWithAutosave()
                : navigate(
                    `/subjects/${content!.subject}/contents`
                );
        }}
        variant="solid"
        colorScheme="red"
        title="Close"
    >
        <FontAwesomeIcon icon={faClose} />
    </Button>
};

export default CloseButton;
